

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/_cof.js
// module id = ../node_modules/core-js/modules/_cof.js
// module chunks = 0